// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2926":"31d6cfe0","6112":"9a7aca85","6816":"546f8f8d","7209":"31d6cfe0"}[chunkId] + ".chunk.css";
};